/** @jsxImportSource ./simboluri-jsx */
import { t, useT, useTn } from "../i18n";
import type { Cheie } from "../i18n";
// «Evidențiază» — al doilea panou al scenei realiste, sub «Ce se vede».
//
// «Ce se vede» răspunde la CE FAMILII DE PIESE sunt pe ecran. Panoul ăsta
// răspunde la altă întrebare, a omului care judecă execuția: UNDE sunt
// piesele de un anumit TIP — toți etrierii de tipul 3, toți stâlpii clasei
// SA. Tipurile sunt exact cele din vederea «Componente» a Studioului
// (`componente.py`), cu aceleași id-uri, ca ce se aprinde în scenă să fie
// rândul pe care îl citești acolo.
//
// UN SINGUR lucru evidențiat la un moment dat: două evidențieri în același
// aur nu se mai pot deosebi, iar întrebarea e mereu una. Alegerea unei
// familii o stinge pe cealaltă.

import type { Evidentiere, FamilieComponenta, TipComponenta }
  from "./armatura3d";

export const FAMILII: [FamilieComponenta, Cheie][] = [
  ["bare", "struct.evid.familie_bare"],
  ["etrieri", "struct.evid.familie_etrieri"],
  ["stalpi", "struct.evid.familie_stalpi"],
  ["grinzi", "struct.evid.familie_grinzi"],
  ["fundatie", "struct.evid.familie_fundatie"],
];

/** valoarea din `<select>`: „" = nimic, „*" = toată familia, altfel id-ul */
const TOATE = "*";

function optiune(cat: FamilieComponenta, x: TipComponenta): string {
  // bara / etrierul se numesc pe id («tip 3»), fiindcă id-ul e ordinalul de
  // utilizare; clasa de element își poartă eticheta (SA, BC)
  const peId = cat === "bare" || cat === "etrieri";
  const nume = peId ? t("struct.evid.tip", { n: x.tip }) : x.tip;
  const unde = peId
    ? x.elemente
      ? t("struct.evid.bucati_in", { n: x.nr ?? "?", elemente: x.elemente })
      : t("struct.evid.bucati", { n: x.nr ?? "?" })
    : t("struct.evid.elemente", { n: x.nr ?? "?" });
  return `${nume} · ${x.descriere ?? ""} · ${unde}`;
}

export default function Evidentiere3D({
  tipuri,
  valoare,
  onChange,
}: {
  tipuri: Record<FamilieComponenta, TipComponenta[]>;
  valoare: Evidentiere;
  onChange: (ev: Evidentiere) => void;
}) {
  const tr = useT();
  const trn = useTn();
  const familii = FAMILII.filter(([cat]) => (tipuri[cat] ?? []).length > 0);
  if (!familii.length) return null;
  return (
    <div className="fem-evid" data-testid="evidentiere-3d">
      <div className="fem-toggles-cap">
        <span className="ob-lbl">{tr("struct.evid.titlu")}</span>
        <span className="fem-toggles-actiuni">
          <button type="button" onClick={() => onChange(null)}
                  disabled={!valoare}
                  title={tr("struct.evid.nimic_titlu")}>
            {tr("struct.evid.nimic")}
          </button>
        </span>
      </div>
      {familii.map(([cat, nume]) => {
        const lista = tipuri[cat] ?? [];
        const activ = valoare?.cat === cat;
        const v = !activ ? "" : valoare!.tip == null ? TOATE : valoare!.tip;
        return (
          <label key={cat} className="fem-evid-rand"
                 title={trn("struct.evid.rand#n", lista.length, { nume: tr(nume) })}>
            <span className="fem-pastila"
                  style={{ background: activ ? "#e8a33a" : "transparent" }} />
            <span className="fem-evid-nume">{tr(nume)}</span>
            <select
              value={v}
              onChange={(e) => {
                const x = e.target.value;
                onChange(x === "" ? null
                  : { cat, tip: x === TOATE ? null : x });
              }}
            >
              <option value="">—</option>
              <option value={TOATE}>
                {trn("struct.evid.toate#n", lista.length)}
              </option>
              {lista.map((x) => (
                <option key={x.tip} value={x.tip}>{optiune(cat, x)}</option>
              ))}
            </select>
          </label>
        );
      })}
    </div>
  );
}
